import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { DreamSection } from './components/DreamSection';
import { AboutIngri } from './components/AboutIngri';
import { TanningSection } from './components/TanningSection';
import { PhotoGallery } from './components/PhotoGallery';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { Urgency } from './components/Urgency';
import { CTASection } from './components/CTASection';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-ink selection:bg-gold selection:text-white" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PhotoGallery data-id="element-4" />
        <DreamSection data-id="element-5" />
        <AboutIngri data-id="element-6" />
        <TanningSection data-id="element-7" />
        <Testimonials data-id="element-8" />
        <Guarantee data-id="element-9" />
        <Urgency data-id="element-10" />
        <CTASection data-id="element-11" />
        <FAQ data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
    </div>;
}